import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSearch }  from '@fortawesome/fontawesome-pro-regular';
import { NsbaMemberSearchService } from '../../../providers/nsba-member-search.service';
import { Nsba_member } from '../../../models/nsba_member';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-nsba-member-search',
  templateUrl: './modal-nsba-member-search.component.html',
styleUrls:  ['./modal-nsba-member-search.component.css']
})
export class ModalNsbaMemberSearchComponent extends SmsAbstractAppPage implements OnInit {

	faSearch = faSearch;
	search_results: Nsba_member[] = [];
	person_selected$: EventEmitter<Nsba_member> = new EventEmitter<Nsba_member>();
	selected_state: string = "";
	entity_type: string = 'I';

  constructor(public activeModal: NgbActiveModal, private nsbaMemberSearchService: NsbaMemberSearchService) {
  	super();
  }

  ngOnInit() {
  }

  handleSearch(search_term: string){
  	this.nsbaMemberSearchService.getByTerm(search_term).then(search_results => {
  		this.search_results = search_results;
      document.getElementById('list-search-results').scrollIntoView();
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

	handleSelect(nsba_member: Nsba_member){
		this.person_selected$.emit(nsba_member);
	}

}
